import { AdsUser } from "./ads-user";
import { Assignment } from "./assignment";
import { Organization } from "./organization";

export class AdsPlacement {
    id: number;
    name: string;
    status: string;
    organization: Organization;
    created_at: Date;
    created_by: AdsUser;
    updated_at: Date;
    updated_by: AdsUser;
    assignment_id: number;
    assignment: Assignment;
    organization_id: number;
    start_date: string;
    end_date: string;
}
